<template>
    <div>
        <template v-if="isPageAllowed">
            <div>
                <div class="wrap full-h">
                    <div class="left border-right" style="height: calc(100vh - 100px);">

                        <div class="my-tree-wrap" v-loading="dataLoading">
                            <el-tree ref="tree" :data="departmentData" :props="defaultProps" node-key="id"
                                highlight-current :expand-on-click-node="false"
                                :default-expanded-keys="defaultExpandedIdArr" @node-expand="handleNodeExpand"
                                @node-collapse="handleNodeCollapse" @node-click="handleNodeClick">
                                <div class="custom-tree-node" slot-scope="{ node, data }">
                                    <p class="font12px" :class="{ 'text-color-bbb': data.disable }" :title="node.label">
                                        {{
                                            node.label }}<span v-if="node.level <= 8">({{ data.count || '-' }})</span></p>
                                </div>
                            </el-tree>
                        </div>


                    </div>
                    <div class="right pl20 pr20 full-h">
                        <div>
                            <el-row type="flex" justify="space-between">
                                <el-col :span="16">
                                    <p class="font14px">
                                        <template
                                            v-if="currentDepartment.group_id && currentDepartment.group_id != '1'">
                                            <span class="department-name mr20 text-bold inline-block">{{
                                                currentDepartment.group_name }}</span>
                                            <span class="inline-block mr20" style="min-width: 120px;">负责人：{{
                                                currentDepartment.leader_name || '--' }}</span>
                                        </template>
                                    </p>
                                </el-col>
                                <el-col :span="6">
                                    <p class="tar">
                                    </p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="filter-bar mt20">
                            <el-row type="flex" class="row-bg" justify="space-between">
                                <el-col :span="24">
                                    <div class="grid-content">
                                        <el-form :inline="true" :model="formItem" @keyup.enter.native="getMemberList">
                                            <el-form-item label="" label-width="0px">
                                                <el-input v-model.trim="formItem.search" clearable
                                                    placeholder="根据成员姓名、手机号、邮箱搜索" style="width: 275px;">
                                                    <el-button slot="append" icon="el-icon-search"
                                                        @click="getMemberList"></el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="角色：">
                                                <ESelect v-model="formItem.role_id" filterable @change="getMemberList"
                                                    clearable style="width: 150px;">
                                                    <el-option value="" label="全部">全部</el-option>
                                                    <el-option v-for="item in roleList" :label="item.role_name"
                                                        :value="item.id" :key="item.id">{{ item.role_name }}
                                                    </el-option>
                                                </ESelect>
                                            </el-form-item>
                                            <el-form-item label="启用状态：">
                                                <el-select v-model="formItem.status" @change="getMemberList" clearable
                                                    style="width: 90px;">
                                                    <el-option label="全部" value="">全部</el-option>
                                                    <el-option label="启用" value="1">启用</el-option>
                                                    <el-option label="禁用" value="0">禁用</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="在职状态：">
                                                <el-select v-model="formItem.user_status" @change="getMemberList"
                                                    clearable style="width: 100px;">
                                                    <el-option label="全部" value="">全部</el-option>
                                                    <el-option label="在职" value="1">在职</el-option>
                                                    <el-option label="离职" value="2">离职</el-option>
                                                    <el-option label="无状态" value="0">无状态</el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="data-list">
                            <div class="batch-tool-bar mb10">
                                <div>
                                    <el-button type="primary" class="batch-enable-btn" plain
                                        v-if="pageFuncNames.includes('rollback_disable')"
                                        :disabled="memberSelected.length <= 0" size="mini"
                                        v-matomo="{ behaviorCategory: '组织架构管理', event: '点击', name: '启用' }"
                                        @click="batchEditUserStatus">启用
                                    </el-button>
                                    <el-button type="danger" class="batch-disable-btn" plain
                                        v-if="pageFuncNames.includes('disable_user')"
                                        :disabled="memberSelected.length <= 0" size="mini"
                                        v-matomo="{ behaviorCategory: '组织架构管理', event: '点击', name: '禁用' }"
                                        @click="batchDisableMember">禁用
                                    </el-button>

                                    <el-button type="primary" class="batch-wework-btn" plain
                                        v-if="pageFuncNames.includes('sync_wework_id')"
                                        :disabled="memberSelected.length <= 0" size="mini"
                                        v-matomo="{ behaviorCategory: '组织架构管理', event: '点击', name: '获取企微ID' }"
                                        @click="batchGetWeWorkId">获取企微ID
                                    </el-button>

                                    <el-button type="primary" class="batch-wework-btn" plain
                                        v-if="pageFuncNames.includes('release_resource')"
                                        :disabled="memberSelected.length <= 0" size="mini"
                                        v-matomo="{ behaviorCategory: '组织架构管理', event: '点击', name: '释放资源' }"
                                        @click="batchReleaseResource">释放资源
                                    </el-button>
                                    <el-button type="primary" class="batch-wework-btn" plain
                                        v-if="pageFuncNames.includes('edit_user')"
                                        :disabled="memberSelected.length <= 0" size="mini"
                                        v-matomo="{ behaviorCategory: '组织架构管理', event: '点击', name: '批量编辑' }"
                                        @click="batchEdit">批量编辑
                                    </el-button>

                                    <span class="ml20" v-if="memberSelected.length > 0">
                                        已选中 {{ memberSelected.length }} 条
                                    </span>
                                </div>

                                <el-button v-if="is_admin" @click="exportData" size="mini">导出</el-button>
                            </div>

                            <div style="position: relative;flex: 1;">
                                <div class="table-wrap" style="position: absolute;width: 100%;">
                                    <el-table ref="memberTable" class="relative fixed_sp" v-loading="dataLoading"
                                        @select="memberSelectionChange" @select-all="memberSelectionChangeAll" stripe
                                        :header-cell-style="{ background: '#e8eaec', color: '#333' }"
                                        :default-sort="{ prop: 'create_time', order: 'descending' }"
                                        @sort-change="handleSortChange" style="width: 100%;height: auto"
                                        :max-height="tableHeight" :data="contentMemberList"
                                        v-el-table-infinite-scroll="load" :infinite-scroll-disabled="disabled">
                                        <el-table-column type="selection" align="center" :selectable="checkSelectable"
                                            min-width="55">
                                        </el-table-column>
                                        <el-table-column label="姓名" width="80" prop="name">
                                        </el-table-column>

                                        <el-table-column v-if="pageFieldsNames.includes('status')" label="启用状态"
                                            min-width="80">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.status == '1'" class="mr6 text-color-success">•
                                                    启用</span>
                                                <span v-if="scope.row.status == '0'" class="mr6 text-color-gray">•
                                                    禁用</span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column v-if="pageFieldsNames.includes('user_status')" label="在职状态"
                                            min-width="80">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.user_status == '1'"
                                                    class="mr6 text-color-success">在职</span>
                                                <span v-else-if="scope.row.user_status == '2'" class="mr6">离职</span>
                                                <span v-else class="mr6">无状态</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="pageFieldsNames.includes('mobile')" align="center"
                                            min-width="100" label="手机号">
                                            <template slot-scope="scope">
                                                <span class="mr6">{{ scope.row.mobile || '--' }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="pageFieldsNames.includes('email')" min-width="165"
                                            align="center" label="邮箱">
                                            <template slot-scope="scope">
                                                <span class="mr6 work-order-title ellipsis el_block">{{ scope.row.email
                                                    || '--' }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="pageFieldsNames.includes('role_name')" align="center"
                                            min-width="120" label="角色">
                                            <template slot-scope="scope">
                                                <span class="mr6 work-order-title ellipsis el_block">{{
                                                    scope.row.role_name || '--' }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="pageFieldsNames.includes('group_name')" align="center"
                                            min-width="100" label="部门">
                                            <template slot-scope="scope">
                                                <el-tooltip :content="scope.row.group_name_with_parent" placement="top">
                                                    <span v-if="!scope.row.group_name">--</span>
                                                    <span v-else-if="scope.row.group_name.length <= 8">{{
                                                        scope.row.group_name }}</span>
                                                    <span v-else>{{ scope.row.group_name.substring(0, 8) }}...</span>
                                                </el-tooltip>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="pageFieldsNames.includes('user_data_action')"
                                            align="center" min-width="120" label="部门数据权限">
                                            <template slot-scope="scope">
                                                <span class="mr6 work-order-title ellipsis el_block">{{
                                                    scope.row.user_data_action || '--' }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="80" align="center" prop="id" label="成员ID" />
                                        <el-table-column min-width="150" align="center" prop="wework_uid"
                                            label="企微ID" />
                                        <el-table-column align="center" prop="address" fixed="right" label="操作">
                                            <template slot-scope="scope">
                                                <el-dropdown @command="handleMemberCommand(scope.row, $event)">
                                                    <span class="el-dropdown-link">
                                                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item v-if="pageFuncNames.includes('get_user_info')"
                                                            command="detail">查看详情</el-dropdown-item>
                                                        <el-dropdown-item v-if="pageFuncNames.includes('edit_user')"
                                                            :disabled="scope.row.name == name || scope.row.status !== '1'"
                                                            command="edit">编辑
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="pageFuncNames.includes('edit_user_department_auth')"
                                                            :disabled="scope.row.name == name || scope.row.status !== '1'"
                                                            command="editAction">修改部门权限
                                                        </el-dropdown-item>

                                                        <el-dropdown-item
                                                            v-if="pageFuncNames.includes('sync_wework_id')"
                                                            command="qw_id">获取企微ID
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="pageFuncNames.includes('grant_authorization')"
                                                            :disabled="scope.row.name == name" command="auth">授权
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            v-if="pageFuncNames.includes('release_resource')"
                                                            :disabled="scope.row.name == name" command="release">释放资源
                                                        </el-dropdown-item>
                                                        <el-dropdown-item v-if="pageFuncNames.includes('disable_user')"
                                                            :disabled="scope.row.name == name || scope.row.status !== '1'"
                                                            command="disabled"><span
                                                                :class="{ 'text-color-error': scope.row.name !== name && scope.row.status == '1' }">禁用</span>
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <DepartmentModal ref="departmentModal" @update="updateDepartmentMemberList" :id="actionDepartment.id" />
                <MemberModal ref="memberModal" :cur-group="currentDepartment.group_id" :ids="actionUser.id"
                    @update="updateDepartmentMemberList" />
                <DisabledUserDrawer :func="pageFuncNames" :fields="pageFieldsNames" ref="disabledUserDrawer"
                    @update="updateDepartmentMemberList" />
                <UserInfoDrawer :func="pageFuncNames" :fields="pageFieldsNames" ref="userInfoDrawer"
                    :id="actionUser.id" />
                <!--<MemberDepartmentModal ref="memberDepartmentModal" :user-list="memberSelected" @update="updateDepartmentMemberList" @close="closeMemberDepartmentModal"/>-->
                <MemberStatusModal ref="memberStatusModal" :user-list="memberSelected"
                    @update="updateDepartmentMemberList" @close="closeMemberDepartmentModal" />
                <MemberActionModal ref="memberActionModal" :user="actionUser" @update="getMemberList" />
                <MemberAuthModal ref="memberAuthModal" :user="actionUser" @update="getMemberList" />
                <MemberReleaseModal ref="memberReleaseModal" :user="actionUser" @update="getMemberList" />
                <div>
                    <el-tooltip ref="cellTip" v-model="showTips" placement="top" effect="dark" :open-delay="0">
                        <div class="tip-mi-content" slot="content">{{ tipContent }}</div>
                    </el-tooltip>
                </div>
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>此页面可对所有组织架构与成员进行管理。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DepartmentModal from './modal/department';
import MemberModal from './modal/member';
import DisabledUserDrawer from './drawer/disabledUser';
import UserInfoDrawer from './drawer/userInfo';
// import MemberDepartmentModal from './modal/memberDepartment';
import MemberStatusModal from './modal/memberStatus';
import MemberActionModal from './modal/memberAction2';
import MemberAuthModal from './modal/memberAuth';
import MemberReleaseModal from './modal/memberRelease';
import API from '@/api/department.js';
import { pageMixin } from '../mixins/pageMixin';
import NoPermissionInfo from '@/components/noPermissionInfo';
import utils from '@/libs/utils.js';
import { debounce } from 'lodash'
import ElTableInfiniteScroll from "el-table-infinite-scroll";
import { tipModal } from './modal/index.js';
export default {
    name: "OrganizationManagement",
    mixins: [pageMixin],
    components: {
        DepartmentModal,
        MemberModal,
        DisabledUserDrawer,
        UserInfoDrawer,
        // MemberDepartmentModal,
        MemberStatusModal,
        MemberActionModal,
        MemberAuthModal,
        MemberReleaseModal,
        NoPermissionInfo,
    },
    directives: {
        "el-table-infinite-scroll": ElTableInfiniteScroll,
    },
    data() {
        return {
            showTips: false,
            tipContent: '',
            showPopper: false, //popper浮层提醒
            popContent: '',
            dataLoading: false,
            departmentData: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            formItem: {
                group_id: '',
                // bind_wx: '',
                role_id: '',
                search: '',
                // order_by:'create_time',
                // order_type:'desc',
                status: '',
                user_status: '',
            },
            roleList: [],
            statusList: [
                {
                    id: '0',
                    name: '未绑定',
                },
                {
                    id: '1',
                    name: '已绑定',
                },
            ],
            memberList: [],
            actionDepartment: {
                id: '',
            },
            actionUser: {
                id: '',
            },
            currentDepartment: {
                leader_name: '',
                group_name: '',
                group_id: '',
            },
            memberSelected: [],
            defaultExpandedIdArr: [],
            /* 为了解决默认排序显示问题，需配合列表的key使用 */
            pageFields: [{
                name: 'create_time'
            }],

            disabled: false,
            page: 0,
            contentMemberList: [],
            tableHeight: 500
        }
    },
    computed: {
        ...mapGetters(['name', 'is_admin']),

    },
    created() {
        let $routeParams = this.$route.params;
        if ($routeParams.role_id) {
            this.formItem.role_id = $routeParams.role_id;
        }

    },
    mounted() {
        this.getEventTip()
        this.$nextTick(() => {
            this.tableHeight = document.body.offsetHeight - 230
        })
    },
    methods: {
        getEventTip() {
            const _this = this;
            const cellTip = this.$refs.cellTip;
            // 超长提示事件
            $(this.$el).on('mouseenter', '.work-order-title', debounce(function () {
                _this.showTips = false;
                const $cell = $(this);
                if ($cell[0].clientWidth >= $cell[0].scrollWidth) {
                    return;
                }
                cellTip.referenceElm = $cell[0];
                _this.showTips = true;
                _this.tipContent = $cell.text();
            }, 100))
                .on('mouseleave', '.work-order-title', debounce(function () {
                    if (!_this.showTips) {
                        return;
                    }
                    _this.$nextTick(() => {
                        _this.showTips = false;
                    })
                }, 150));
        },
        load() {
            if (this.disabled) return;

            this.page++;
            const total = Math.ceil(this.memberList.length / 40);
            if (this.page <= this.memberList.length) {
                this.contentMemberList = this.memberList.slice(0, this.page * 40)
            }
            if (this.page === total) {
                this.disabled = true;
            }

            this.$nextTick(() => {
                if (this.memberSelected.length != 0) {
                    this.memberSelected.forEach(row => {
                        this.$refs.memberTable.toggleRowSelection(row);
                    });
                }
                this.$forceUpdate()
            })

        },
        initPageStates() {
            /* 默认筛选在职状态 */
            if (this.pageFieldsNames.includes('user_status')) {
                this.formItem.user_status = this.formItem.user_status || '1';
            }
            this.getDepartmentTree();
            this.getRoleList();
            this.getMemberList();
        },
        handleNodeClick(data) {
            this.formItem.group_id = data.id;
            this.currentDepartment.group_name = data.name;
            this.currentDepartment.group_id = data.id;
            this.currentDepartment.leader_name = '';
            this.getRoleList();
            this.getMemberList();
        },
        showDepartmentModal() {
            this.actionDepartment = {
                id: '',
            };
            this.$refs.departmentModal.showModal();
        },
        addMember() {
            this.actionUser.id = '';
            this.showMemberModal();
        },
        showMemberModal() {
            this.$refs.memberModal.showModal();
        },
        showDisabledUserDrawer() {
            this.$refs.disabledUserDrawer.showDrawer();
        },
        getDepartmentTree(isMoveNode) {
            API.getTree().then(res => {
                let resData = res.data || {};
                this.departmentData = [res.data];
                if (resData && resData.id) {
                    this.$nextTick(() => {
                        let $tree = this.$refs.tree;
                        if (this.currentDepartment.group_id) {
                            if ($tree) {
                                $tree.setCurrentKey(this.currentDepartment.group_id);
                            }
                            let currentGroup = this._findGroupById(this.departmentData, this.currentDepartment.group_id);
                            if (currentGroup) {
                                this.currentDepartment.group_name = currentGroup.name;
                            }
                        } else {
                            if ($tree) {
                                $tree.setCurrentKey(resData.id);
                            }
                            this.currentDepartment.group_name = resData.name;
                            this.currentDepartment.group_id = resData.id;
                        }
                        if (!isMoveNode) {
                            this.getNodeLevel(resData.id);
                        }
                    });
                }
            }, (err) => {
                this.departmentData = [];
            });
        },
        _findGroupById(data, id) {
            for (let item in data) {
                if (data[item].id == id) {
                    return data[item];
                } else {
                    let child = data[item].children;
                    if (child && child.length > 0) {
                        let result = this._findGroupById(child, id);
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        },
        getNodeLevel(id) {
            let $tree = this.$refs.tree;
            let node = $tree ? $tree.getNode(id) : {};
            if (node.level < 4) {
                this.defaultExpandedIdArr.push(node.data.id);
                this.$nextTick(() => {
                    if (node.data.children) {
                        node.data.children.map(item => {
                            this.getNodeLevel(item.id)
                        })
                    }
                })
            }
        },
        editDepartment(data) {
            this.actionDepartment.id = data.id;
            this.$refs.departmentModal.showModal();
        },
        moveDepartment(data, type) {
            API.moveGroup({
                id: data.id,
                type,
            }).then(res => {
                this.$message.success(res.info || '操作成功');
                this.getDepartmentTree(true);
                this.getMemberList();
            }, (err) => {
                this.$message.error(err.info || '操作失败');
            });
        },
        deleteDepartment(data) {
            let count = data.count;
            if (count > 0) return this.$message.error('该部门内存在成员，不可删除');
            this.$messageBox.confirm(`即将删除部门【${data.name}】，确认要删除吗？`, '提示', {
                closeOnPressEscape: false,
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.deleteGroup({
                    id: data.id,
                }).then(res => {
                    this.$message.success(res.info || '操作成功');
                    this.getDepartmentTree();
                }, (err) => {
                    this.$message.error(err.info || '操作失败');
                });
            }).catch(() => {

            });
        },
        handleDepartmentCommand(data, val) {
            switch (val) {
                case 'edit':
                    this.editDepartment(data);
                    break;
                case 'moveUp':
                    this.moveDepartment(data, 'up');
                    break;
                case 'moveDown':
                    this.moveDepartment(data, 'down');
                    break;
                case 'delete':
                    this.deleteDepartment(data);
                    break;
            }
        },
        getMemberList() {
            this.dataLoading = true;
            API.getMemberList({
                group_id: this.formItem.group_id,
                // bind_wx: this.formItem.bind_wx,
                role_id: this.formItem.role_id,
                search: this.formItem.search,
                order_by: this.formItem.order_by,
                order_type: this.formItem.order_type,
                status: this.formItem.status,
                user_status: this.formItem.user_status,
            }).then(res => {
                let resData = res.data || {};
                this.memberList = resData.list || [];
                this.page = 0
                this.disabled = false
                this.memberSelected = []
                if (this.memberList.length != 0) {
                    this.load()
                } else {
                    this.contentMemberList = []
                }
                this.currentDepartment.leader_name = resData.leader_name;
                this.dataLoading = false;
            }, (err) => {
                this.memberList = [];
                this.dataLoading = false;
            });
        },
        getRoleList() {
            this.roleList = [];
            API.getSearchRoleList({
                group_id: this.formItem.group_id || '',
            }).then(res => {
                this.roleList = res.data || [];
            }, (err) => {
                this.roleList = [];
            });
        },
        memberSelectionChange(val) {
            this.memberSelected = val.map(item => item);
        },
        memberSelectionChangeAll(val) {
            this.memberSelected = this.memberList
        },
        batchEditMemberDepartment() {
            this.memberSelected = this.$refs.memberTable.selection;
            this.$refs.memberDepartmentModal.showModal();
        },
        batchEditUserStatus() {
            let memberSelected = this.$refs.memberTable.selection.filter(item => item.status != '1');
            if (memberSelected.length <= 0) {
                let $button = document.querySelector('.batch-enable-btn');
                if ($button) {
                    $button.blur();
                }
                return this.$message.error('所选成员已是启用状态');
            }
            this.memberSelected = memberSelected;
            this.$refs.memberStatusModal.showModal();
        },
        batchDisableMember() {
            // this.memberSelected = this.$refs.memberTable.selection;

            let memberSelected = this.$refs.memberTable.selection.filter(item => item.status != '0');
            if (memberSelected.length <= 0) {
                let $button = document.querySelector('.batch-disable-btn');
                if ($button) {
                    $button.blur();
                }
                return this.$message.error('所选成员已是禁用状态');
            }
            this.memberSelected = memberSelected;
            this.disabledMember(this.memberSelected);
        },
        resetPassword(data) {
            this.$messageBox.confirm(`确定要重置【${data.name}】的密码吗？`, '警告', {
                closeOnPressEscape: false,
                confirmButtonText: '确定',
                confirmButtonClass: 'danger-btn',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.resetPassword({
                    id: data.id
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.info || '密码重置成功，新密码已发送至该成员邮箱');
                    } else {
                        this.$message.success(res.info || '操作失败');
                    }
                }, (err) => {
                    this.$message.success(err.info || '操作失败');
                });
            }).catch(() => {

            });
        },
        disabledMember(list) {
            let htmlStr = `<div class="tal">
                    <p>是否确定禁用该成员？禁用后成员将：</p>
                    <p class="pl20">1、无法登录聚投平台</p>
                    <p class="pl20">2、停止发送给该成员的所有通知</p>
                    <p class="pl20">3、脱离角色</p>
                    </div>`;
            this.$messageBox.confirm(htmlStr, '警告', {
                closeOnPressEscape: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: '禁用',
                cancelButtonText: '取消',
                confirmButtonClass: 'danger-btn',
                type: 'warning',
            }).then(() => {
                let ids = list.map(item => item.id);
                API.disableUser({
                    ids: ids.join(','),
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.info || '操作成功');
                        this.getMemberList();
                        this.getDepartmentTree();
                    } else {
                        this.$message.error(res.info || '操作失败');
                    }
                }, (err) => {
                    this.$message.error(err.info || '操作失败');
                });
            }).catch(() => {
                let $button = document.querySelector('.batch-disable-btn');
                if ($button) {
                    $button.blur();
                }
            });
        },
        handleMemberCommand(data, val) {
            switch (val) {
                case 'detail':
                    this.actionUser.id = data.id;
                    this.$refs.userInfoDrawer.showDrawer();
                    break;
                case 'edit':
                    this.actionUser.id = data.id;
                    this.showMemberModal();
                    break;
                case 'resetPassword':
                    this.resetPassword(data);
                    break;
                case 'qw_id'://企业微信
                    this.getWeComId(data);
                    break;
                case 'editGroup':
                    this.memberSelected = [data];
                    this.$refs.memberDepartmentModal.showModal();
                    break;
                case 'editAction':
                    this.actionUser = data;
                    this.$refs.memberActionModal.showModal();
                    break;
                case 'auth':
                    this.actionUser = data;
                    this.$refs.memberAuthModal.showModal();
                    break;
                case 'release':
                    this.actionUser = data;
                    this.$refs.memberReleaseModal.showModal();
                    break;
                case 'disabled':
                    this.disabledMember([data]);
                    break;
            }
        },
        // renderNameHeader(h) {
        //     return h('el-tooltip', {
        //         props: {
        //             effect: "dark",
        //             content: "姓名右侧为微信绑定状态",
        //             placement: "right",
        //         },
        //     }, [
        //         h('span', '姓名'),
        //     ])
        // },
        checkSelectable(row) {
            return row.name !== this.name;
        },
        updateDepartmentMemberList() {
            this.getDepartmentTree();
            this.getMemberList();
        },
        closeMemberDepartmentModal() {
            this.memberSelected = this.$refs.memberTable.selection;
        },
        getNodeLabelText(node) {
            let text = node.label || '--';
            let wordNum = 2;

            switch (node.level) {
                case 1:
                    wordNum = 15;
                    break;
                case 2:
                    wordNum = 12;
                    break;
                case 3:
                    wordNum = 10;
                    break;
                case 4:
                    wordNum = 8;
                    break;
                case 5:
                    wordNum = 7;
                    break;
                case 6:
                    wordNum = 5;
                    break;
                case 7:
                    wordNum = 4;
                    break;
                case 8:
                    wordNum = 2;
                    break;
                case 9:
                    wordNum = 2;
                    break;
                default:
                    wordNum = 2;
            }
            return text.length <= wordNum ? text : text.substring(0, wordNum - 1) + '...';
        },
        handleNodeExpand(data) {
            // 保存当前展开的节点
            let flag = false
            this.defaultExpandedIdArr.some(item => {
                if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
                    flag = true
                    return true
                }
            })
            if (!flag) { // 不存在则存到数组里
                this.defaultExpandedIdArr.push(data.id)
            }
        },
        // 树节点关闭
        handleNodeCollapse(data) {
            this.defaultExpandedIdArr.some((item, i) => {
                if (item === data.id) {
                    // 删除关闭节点
                    this.defaultExpandedIdArr.length = i
                }
            })
        },
        handleSortChange(column) {
            this.formItem.order_type = column.order == 'descending' ? 'desc' : 'asc';
            this.formItem.order_by = column.prop;
            this.getMemberList();
        },
        exportData() {
            /* 不走离线下载，后的直接返回文件供前端下载 */
            let reqData = {
                export: '1',
                group_id: this.formItem.group_id,
                role_id: this.formItem.role_id,
                search: this.formItem.search,
                order_by: this.formItem.order_by,
                order_type: this.formItem.order_type,
                status: this.formItem.status,
                user_status: this.formItem.user_status,
            };
            let baseUrl = '/td/api/user/get_detail_list';
            let url = baseUrl + '?' + utils.toUrlParams(reqData);
            utils.exportFile(url);
        },
        // 获取企业微信id
        async getWeComId(row) {
            try {
                const params = {
                    id: row.id
                }
                const { data } = await API.syncWeworkId(params);
                this.$set(row, 'wework_uid', data[row.id]);
                this.$message.success('获取成功')
            } catch (error) {
                console.log(error);
                this.$message.error(error.info)
            }
        },
        // 批量获取企微ID
        batchGetWeWorkId() {
            const memberSelected = this.memberSelected.map(item => item.id);
            // let pushList = [];
            // this.memberSelected.forEach(item => {
            //     pushList.push(API.syncWeworkId({ id: item.id }));
            // });
            // Promise.allSettled(pushList).then(res => {
            //     let errorList = [];
            //     let successList = [];
            //     res.forEach((item, index) => {
            //         if (item.status === 'rejected') {
            //             errorList.push(memberSelected[index].name);
            //         } else {
            //             successList.push(memberSelected[index].name);
            //         }
            //     });
            //     const { vm } = tipModal(
            //         {
            //             props: {
            //                 errorList,
            //                 successList
            //             },
            //             cbs: {
            //                 close: () => { }
            //             }
            //         }
            //     )
            // })
            API.syncWeworkId({ id: memberSelected.join(',') }).then(res => {
                this.$message.success(res.info)
            }).catch(err => {
                this.$message.error(err.info)
            })
        },
        // 批量释放资源
        batchReleaseResource() {
           const memberSelected = this.memberSelected.filter(item => item.name !== this.name ).map(item => item.id);
           console.log(this.memberSelected, this.name );
           
            if (memberSelected.length <= 0) {
                this.$message.error('所选数据都不可编辑');
                return
            }
            this.$confirm('此操作将释放成员的资源, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.userRelease({ id: memberSelected.join(',') }).then(res => {
                    this.$message.success(res.info)
                }).catch(err => {
                    this.$message.error(err.info)
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消释放'
                });
            });

            
        },
        // 批量编辑角色
        batchEdit() {
           const ids = this.memberSelected.filter(item => item.name !== this.name && item.status == '1').map(item => item.id);
           if (ids.length <= 0) {
                this.$message.error('所选数据都不可编辑');
                return
            }
           this.actionUser.id = ids;
            this.showMemberModal();
        }
    }
}
</script>

<style lang="scss" scoped>
.wrap {
    display: flex;
    height: 100%;
    width: 100%;
}

.left {
    width: 260px;
    background-color: #fff;
    flex: 0 1 auto;
    display: flex;
    flex-direction: column;
}

.right {
    background-color: #fff;
    flex: auto;
    width: 100%;
}

.my-tree-wrap {
    height: 0;
    flex: 1;
    overflow: auto;
}

::v-deep .my-tree-wrap .el-tree-node__children {
    overflow: unset;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.batch-tool-bar {
    display: flex;
    justify-content: space-between;
}

.border-right {
    border-right: solid 1px #ccc;
}

::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #cfe6ff;
}

::v-deep.danger-btn {
    background-color: #ed4014;

    &:hover {
        background-color: #f56c6c;
    }
}

.text-color-bbb {
    color: #bbb;
}

.vertical-bottom {
    vertical-align: bottom;
}

.el_block {
    display: block;
}
</style>

<style lang="scss">
.fixed_sp {
    .el-table__fixed-right {
        height: 100% !important;
    }

    .el-table__fixed {
        height: 100% !important;
    }
}
</style>
